import parse from "html-react-parser";
import DOMPurify from "dompurify";


type SafeHtmlRendererProps = {
    htmlContent: string;
}
export const SafeHtmlRenderer = ({ htmlContent }:SafeHtmlRendererProps) => {
    const cleanHTML = DOMPurify.sanitize(htmlContent);
    return <div>{parse(cleanHTML)}</div>;
};